import z from "zod";
import { USCheckboxFilterSchema } from "./base-schema";
import { USCheckboxValueOptionsSchema } from "./us-checkbox-options";

const UsZoneTypeKeys = [
  "zoning_agriculture",
  "zoning_core_commercial",
  "zoning_general_commercial",
  "zoning_industrial",
  "zoning_light_industrial",
  "zoning_mixed_use",
  "zoning_multi_family",
  "zoning_neighborhood_commercial",
  "zoning_office",
  "zoning_planned",
  "zoning_retail_commercial",
  "zoning_single_family",
  "zoning_special",
  "zoning_special_commercial",
  "zoning_two_family",
] as const;

const ZoneTypeOptionValuesSchema = USCheckboxValueOptionsSchema(UsZoneTypeKeys);

export const USZoneTypeSchema = USCheckboxFilterSchema.extend({
  id: z.literal("zone-type-id"),
  values: z.array(ZoneTypeOptionValuesSchema),
});
